const fieldsMap = {
    pourPoint: {
        min: 'pourPointMin',
        max: 'pourPointMax',
    },
    boilingPoint: {
        min: 'boilingPointMin',
        max: 'boilingPointMax',
    },
    meltingPoint: {
        min: 'meltingPointMin',
        max: 'meltingPointMax',
    },
    voyageHeat: {
        min: 'voyageHeatMin',
        max: 'voyageHeatMax',
    },
    loadingHeat: {
        min: 'loadingHeatMin',
        max: 'loadingHeatMax',
    },
    dischargeHeat: {
        min: 'dischargeHeatMin',
        max: 'dischargeHeatMax',
    },
    numberOfHeads: {
        min: 'numberOfHeadsMin',
        max: 'numberOfHeadsMax',
    },
    moisture: {
        min: 'moistureMin',
        max: 'moistureMax',
    },
    temperature: {
        min: 'temperatureMin',
        max: 'temperatureMax',
    },
};

const getValidateFields = (fieldName) => {
    const initialName = fieldName
        .replace('packing.pack.', '').replace('Min', '').replace('Max', '');

    return fieldsMap[initialName];
};

export { getValidateFields, fieldsMap };



// WEBPACK FOOTER //
// ./app/constants/validateFields.js